import { Input } from '@/components/catalyst/input'
import { forwardRef } from 'react'

interface FormInputProps {
  name?: string
  value?: string | number | null
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  type?: 'text' | 'number' | 'email' | 'password' | 'search' | 'tel' | 'url' | 'date'
  placeholder?: string
  disabled?: boolean
  autoFocus?: boolean
  className?: string
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(function FormInput(
  { value, ...props },
  ref
) {
  return <Input ref={ref} value={value ?? ''} {...props} />
})

export default FormInput
